import { useState, useEffect } from "react";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import { getFichaLink } from "../../utils/fichaUrls";
import checkIcon from "../../assets/check-square.png";

const MOBILE_MAX_WIDTH = 767;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isMobile;
};

const VehicleCard = (vehiculo) => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const tipo = vehiculo.tipo;
  const isMobile = useIsMobile();
  const card = vehiculo.info.convencional;

  if (!card?.habilitado) return null;

  const handleConsultar = (modelo, version, seccion, tipo_financiacion) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      modelo,
      version,
      seccion,
      event: "consultar",
      tipo_financiacion,
    });
    openConsultaForm();
  };

  const onConsult = () => handleConsultar(card.modelo, card.version, tipo, card.titulo_principal);
  const ficha = getFichaLink({ modelo: card.modelo, id: vehiculo.info?.id });

  const interaction = {
    sectionClassName: isMobile ? " card-new-vehicle--tappable" : "",
    sectionOnClick: isMobile ? onConsult : undefined,
    buttonOnClick: isMobile ? undefined : onConsult,
  };

  return (
    <div style={{ width: "100%" }}>
      <section
        className={`card-new-vehicle h-100 d-flex justify-content-between flex-column${interaction.sectionClassName}`}
        onClick={interaction.sectionOnClick}
      >
        <div className="card-new-vehicle-header">
          <h2 className="titulo-tarjeta"> {card.modelo} </h2>
          {card.version !== "" ? <h3 className="titulo-version-tarjeta"> {card.version} </h3> : null}
        </div>
        <div className="card-new-vehicle-imagen">
          <img src={card.main_picture} alt={card.modelo} className="img-fluid" />
        </div>
        <div className="card-new-vehicle-footer">
          {card.entrega_inmediata || card.entrega_por_encargo ? (
            <div className="vehicle-footer-entrega-inmediata text-center">
              <p className="text-center justify-content-center d-flex align-items-center align-content-center">
                <img src={checkIcon} alt="Icon Check" />
                {card.entrega_por_encargo ? "ENTREGA POR ENCARGO" : "DISPONIBILIDAD INMEDIATA"}
              </p>
            </div>
          ) : null}

          {card.descripcion_general.length !== "" ? (
            <div className="vehicle-footer-descripcion-general">
              <p>{card.descripcion_general}</p>
            </div>
          ) : null}

          {card.subtitulo_principal !== "" ? (
            <div className="vehicle-footer-subtitulo-principal">
              <p>{card.subtitulo_principal}</p>
            </div>
          ) : null}

          {card.descripcion_subtitulo_principal !== "" ? (
            <div className="vehicle-footer-descripcion-subtitulo-principal">
              <p>{card.descripcion_subtitulo_principal}</p>
            </div>
          ) : null}

          <div className="vehicle-footer-titulo-principal">
            {card.titulo_principal !== "" ? (
              <p className="vehicle-footer-titulo-principal-a">{card.titulo_principal}</p>
            ) : null}

            {card.descripcion_titulo_principal !== "" ? (
              <p className="vehicle-footer-titulo-principal-b">{card.descripcion_titulo_principal}</p>
            ) : null}

            {card.descripcion_rojo_titulo_principal !== "" ? (
              <p className="vehicle-footer-titulo-principal-c">{card.descripcion_rojo_titulo_principal}</p>
            ) : null}
          </div>
        </div>
        <div className="card-new-vehicle-actions">
          {ficha ? (
            <a
              href={ficha.href}
              className="btn-ver-ficha-card"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {ficha.label}
            </a>
          ) : null}
          <button
            type="button"
            className="btn-consultar-card"
            id={`${card.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
            onClick={interaction.buttonOnClick}
          >
            Consultar
          </button>
        </div>
      </section>
    </div>
  );
};

export default VehicleCard;
